// Copyright (c) 2017 Deere & Company

import _ from 'lodash';

export const getListOfSelectedDealers = selectedAccounts => Object.keys(selectedAccounts).filter(isSelected => selectedAccounts[isSelected]);

export const updateSelectionMap = (previousSelection, key) => ({
    ...previousSelection,
    [key]: !previousSelection[key]
});

export const createHashMap = (list, uniqueIdentifier, state) =>
    list.reduce((previous, current) => ({
        ...previous,
        [_.property(uniqueIdentifier)(current)]: state
    }), {});

export const isEverythingSelected = hashMap => Object.values(hashMap).every(isSelected => isSelected);

// Accounts

export const getHashesToCheck = (collection, key) => collection.reduce((newCollection, currentItem) => newCollection.concat(_.property(key)(currentItem)), []);

// Cities

export const updateSelectedAccountsInACity = (city, selectedAccounts, isSelected) => ({
    ...selectedAccounts,
    ...createHashMap(city.accounts, 'dealer.account', isSelected)
});

// Lead Accounts

export const updateSelectedCitiesInALeadAccount = (leadAccount, selectedCities, isSelected) => ({
    ...selectedCities,
    ...createHashMap(leadAccount.cities, 'id', isSelected)
});

export const updateSelectedAccountsInALeadAccount = (leadAccount, selectedAccounts, isSelected) => leadAccount.cities.reduce((newCities, currentCity) => ({
    ...newCities,
    ...createHashMap(currentCity.accounts, 'dealer.account', isSelected)
}), selectedAccounts);

// Territories

export const updateSelectedLeadAccountsInATerritory = (territory, selectedLeadAccounts, isSelected) => ({
    ...selectedLeadAccounts,
    ...createHashMap(territory.leadAccounts, 'dealer.account', isSelected)
});

export const updateSelectedCitiesInATerritory = (territory, selectedCities, isSelected) => territory.leadAccounts.reduce((newLeadAccounts, currentLeadAccount) => updateSelectedCitiesInALeadAccount(currentLeadAccount, newLeadAccounts, isSelected), selectedCities);

export const updateSelectedAccountsInATerritory = (territory, selectedAccounts, isSelected) => territory.leadAccounts.reduce((newLeadAccounts, currentLeadAccount) => updateSelectedAccountsInALeadAccount(currentLeadAccount, newLeadAccounts, isSelected), selectedAccounts);

export const updateSelectedTerritories = (selectedTerritories, isSelected, territory) => {

    const newSelectedTerritories = {...selectedTerritories};

    newSelectedTerritories[territory] = isSelected;

    return newSelectedTerritories;

};

// Filter

const matchCities = (textToSearch, cities) =>
    cities.reduce((newCities, currentCity) => {

        if (currentCity.city.match(textToSearch)) {

            newCities.push(currentCity);

        } else {

            const matchedAccounts = currentCity.accounts.filter(account => account.dealer.account.match(textToSearch));

            const emptyArray = 0;

            if (matchedAccounts.length > emptyArray) {

                newCities.push({
                    ...currentCity,
                    accounts: matchedAccounts
                });

            }

        }

        return newCities;

    }, []);

const matchLeadAccounts = (textToSearch, leadAccounts) =>
    leadAccounts.reduce((accounts, currentLeadAccount) => {

        if (currentLeadAccount.dealer.name.match(textToSearch)) {

            accounts.push(currentLeadAccount);

        } else {

            const matchedCities = matchCities(textToSearch, currentLeadAccount.cities);

            const emptyArray = 0;

            if (matchedCities.length > emptyArray) {

                accounts.push({
                    ...currentLeadAccount,
                    cities: matchedCities
                });

            }

        }

        return accounts;

    }, []);

export const filterTerritories = (textToSearch, territories) =>
    territories.reduce((newTerritories, currentTerritory) => {

        if (currentTerritory.territory.match(textToSearch)) {

            newTerritories.push(currentTerritory);

        } else {

            const matchedLeadAccounts = matchLeadAccounts(textToSearch, currentTerritory.leadAccounts);

            const emptyArray = 0;

            if (matchedLeadAccounts.length > emptyArray) {

                newTerritories.push({
                    ...currentTerritory,
                    leadAccounts: matchedLeadAccounts
                });

            }

        }

        return newTerritories;

    }, []);

// Init

export const generateSelectionMap = territories => ({
    selectedAccounts: territories.reduce((newTerritories, currentTerritory) => updateSelectedAccountsInATerritory(currentTerritory, newTerritories, true), {}),
    selectedCities: territories.reduce((newTerritories, currentTerritory) => updateSelectedCitiesInATerritory(currentTerritory, newTerritories, true), {}),
    selectedLeadAccounts: territories.reduce((newTerritories, currentTerritory) => updateSelectedLeadAccountsInATerritory(currentTerritory, newTerritories, true), {}),
    selectedTerritories: createHashMap(territories, 'territory', true)
});




// WEBPACK FOOTER //
// ./src/shared/components/facets/dealer-hierarchy/helpers.js